module.exports = __webpack_public_path__ + "img/1f645.69681bd.svg";